export default {"src":"/_next/static/media/homepage-twitter-footer-icon-desktop-white.902dbd30.svg","height":29,"width":36,"blurWidth":0,"blurHeight":0};